export default "__VITE_ASSET__776906e8__"